// Centralised admin auth helpers (token in localStorage + axios header)
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;
export const ADMIN_TOKEN_KEY = "ideaclap-admin-token";

export const getToken = () => {
    try {
        return localStorage.getItem(ADMIN_TOKEN_KEY) || "";
    } catch {
        return "";
    }
};

export const setToken = (t) => {
    try {
        if (t) localStorage.setItem(ADMIN_TOKEN_KEY, t);
        else localStorage.removeItem(ADMIN_TOKEN_KEY);
    } catch {
        /* ignore */
    }
};

export const adminGet = (path) =>
    axios.get(`${ADMIN_API}${path}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
    });

export const adminPost = (path, body) =>
    axios.post(`${ADMIN_API}${path}`, body, {
        headers: { Authorization: `Bearer ${getToken()}` },
    });

export const adminLogin = (password) =>
    axios.post(`${ADMIN_API}/login`, { password });

export const adminLogout = () => adminPost("/logout", {});
